<template>
  <div class="config-glance flex flex-col">
    <div class="flex">

      <!-- primary skill -->
      <div class="config-ps">
        <div class="ps-item" v-for="item in psKills">
          <div class="skill-icon h-outer-border around-4 bw2 bz0">
            <img :src="`${$rHost}/img/ui/${psIconMap[item]}.jpg`" alt="">
            <div class="ps-num">
              {{ ps[item] }}
            </div>
          </div>
        </div>
      </div>

      <!-- 部队 -->
      <div class="config-tr">
        <div class="tr-item" v-for="item in tr">
          <div class="creature-icon h-outer-border around-4 bw2 bz0">
            <img :class="[item.name ? '' : 'placeholder']" :src="creatureIconUrl(item.name)" alt="">
          </div>
          <div class="amount">
            {{ item.amount }}
          </div>
        </div>
      </div>

      <!-- secondary skill -->
      <div class="config-ss" v-if="ssInPage && ssInPage.length">
        <button :disabled="ssPrevDisable" v-click-sound-button class="h-btn LEFTARN" @click.stop="handlePrevPageSs"></button>
        <div class="ss-item" v-for="item in ssInPage">
          <div class="skill-icon h-outer-border around-4 bw2 bz0">
            <img :class="[item.name ? '' : 'placeholder']" :src="skillIconUrl(item.name, item.value)" alt="">
          </div>
        </div>
        <button :disabled="ssNextDisable" v-click-sound-button class="h-btn RIGHTARN" @click.stop="handleNextPageSs"></button>
      </div>

    </div>

    <div class="mt-2">
      <!-- 法术 -->
      <div class="config-sp" v-if="spInPage && spInPage.length">
        <button :disabled="spPrevDisable"  v-click-sound-button class="h-btn LEFTARN" @click.stop="handlePrevPageSp"></button>
        <div class="ps-item" v-for="name in spInPage">
          <div class="skill-icon h-outer-border around-4 bw2 bz0">
            <img :class="[name ? '' : 'placeholder']" :src="spellIconUrl(name)" alt="">
          </div>
        </div>
        <button :disabled="spNextDisable" v-click-sound-button class="h-btn RIGHTARN" @click.stop="handleNextPageSp"></button>
      </div>
    </div>

  </div>
</template>

<script>
  import secondarySkillsConfig from '@js/config/resource/secondary-skills-config'

  export default {
    name: 'config-glance',

    data () {
      return {
        psKills: [
          'a',
          'd',
          'p',
          'k',
        ],
        psIconMap: {
          a: 'PSKIL42A',
          d: 'PSKIL42D',
          p: 'PSKIL42P',
          k: 'KNOW',
        },
        ssPager: {
          page: 0,
          pageSize: 8,
        },
        spPager: {
          page: 0,
          pageSize: 20,
        },
      }
    },

    props: {
      config: {
        type: Object,
        default () {
          return {}
        }
      }
    },

    computed: {
      ps () {
        return this.config.ps
      },
      ss () {
        return this.config.ss.map((d) => {
          const name = Object.keys(d)[0]
          return {
            name,
            value: d[name]
          }
        })
      },

      maxSsPage () {
        return Math.ceil(this.ss.length / this.ssPager.pageSize) - 1
      },

      ssPrevDisable () {
        return this.ssPager.page <= 0
      },

      ssNextDisable () {
        return this.ssPager.page >= this.maxSsPage
      },

      ssInPage () {
        const { page, pageSize } = this.ssPager
        const start = page * pageSize
        const end = (page + 1) * pageSize
        const res = this.ss.slice(start, end)

        if (res.length < this.ssPager.pageSize) {
          res.push(...new Array(this.ssPager.pageSize - res.length).fill({}))
        }

        return res
      },

      sp () {
        return this.config.sp
      },

      maxSpPage () {
        return Math.ceil(this.sp.length / this.spPager.pageSize) - 1
      },

      spPrevDisable () {
        return this.spPager.page <= 0
      },

      spNextDisable () {
        return this.spPager.page >= this.maxSpPage
      },

      spInPage () {
        const { page, pageSize } = this.spPager
        const start = page * pageSize
        const end = (page + 1) * pageSize
        const res = this.sp.slice(start, end)

        if (res.length < pageSize) {
          res.push(...new Array(pageSize - res.length).fill(null))
        }

        return res
      },

      tr () {

        return this.config.tr.map((d) => {
          const name = Object.keys(d)[0]
          return {
            name,
            amount: d[name]
          }
        })
      },
    },

    methods: {
      skillIconUrl (name, level) {
        if (!name) {
          return `${this.$rHost}/img/creature/avatar/CPRLBLK.jpg`
        }
        const conf = secondarySkillsConfig.find((d) => d.name === name)
        const sourceName = conf?.sourceName + (['A', 'A', 'B', 'C'][level] || '')
        return `${this.$rHost}/img/common/secondary_skill/${sourceName}.jpg`
      },

      spellIconUrl (name) {
        if (!name) {
          return `${this.$rHost}/img/creature/avatar/CPRLBLK.jpg`
        }
        return `${this.$rHost}/img/spell/${name}.png`
      },

      creatureIconUrl (name) {
        if (!name) {
          return `${this.$rHost}/img/creature/avatar/CPRLBLK.jpg`
        }
        return `${this.$rHost}/img/creature/avatar/${name}.jpg`
      },

      handlePrevPageSs () {
        this.ssPager.page = Math.max(0, this.ssPager.page - 1)
      },

      handleNextPageSs () {
        this.ssPager.page = Math.min(this.maxSsPage, this.ssPager.page + 1)
      },

      handlePrevPageSp () {
        this.spPager.page = Math.max(0, this.spPager.page - 1)
      },

      handleNextPageSp () {
        this.spPager.page = Math.min(this.maxSpPage, this.spPager.page + 1)
      },
    },

  }
</script>

<style lang="stylus" scoped>
  .config-glance
    padding 2px
    display flex

  .skill-icon > .placeholder
    width 100%
    max-height none

  .config-ps
    display flex
    .skill-icon
      position relative
      width 30px
      height 30px
      padding 2px
      > img
        width 26px
        height 26px
      .ps-num
        position absolute
        width 100%
        left 0
        bottom 2px
        font-size 12px
        line-height 12px
        text-align center
        letter-spacing 1px
        transform-origin center bottom
        transform scale(0.75)
        color $colorWhite
        text-shadow 1px 1px 1px #000

  .config-ss
    display flex
    .h-btn
      width 12px
      height 30px
    .skill-icon
      position relative
      display flex
      justify-content center
      align-items center
      width 30px
      height 30px
      padding 2px
      > img
        max-width 100%
        max-height 100%

  .config-sp
    display flex
    .h-btn
      width 12px
      height 30px
    .skill-icon
      position relative
      display flex
      justify-content center
      align-items center
      width 30px
      height 30px
      padding 2px
      > img
        max-width 100%
        max-height 100%

  .config-tr
    position relative
    display flex
    margin 0 15px
    &:before
      content ""
      position absolute
      left -8px
      top 2px
      width 1px
      height calc(100% - 4px)
      background-color #716452
      box-shadow 1px 1px 0 #211c10
    &:after
      content ""
      position absolute
      right -8px
      top 2px
      width 1px
      height calc(100% - 4px)
      background-color #716452
      box-shadow 1px 1px 0 #211c10
    .h-btn
      width 12px
      height 22px
    .tr-item
      position relative
    .creature-icon
      overflow hidden
      position relative
      display flex
      justify-content center
      align-items center
      width 30px
      height 30px
      padding 2px
      > img
        max-width 100%
    .amount
      position absolute
      width 100%
      bottom 2px
      left 0
      height 12px
      background-color rgba(0, 0, 0, 0.1)
      line-height 12px
      font-size 12px
      transform-origin center bottom
      transform scale(0.75)
      text-align center
      whiteText1()

</style>
